<div class="kt-holder kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
    <div class="kt-subheader   kt-grid__item" id="kt_subheader">
        <div class="kt-subheader__main">
            <app-breadcrumb-kiosk-offline-log [companyId]="companyId"></app-breadcrumb-kiosk-offline-log>
        </div>
        <!-- <div class="kt-subheader__toolbar">
            <div class="kt-subheader__wrapper d-flex align-items-center" *ngIf="roleMatrix.role === roles.OrgAdmin">
                <label class="fs-md">All Data</label>
                <label class="switch switch-sm ml-2 mr-2">
                    <input type="checkbox" [(ngModel)]="showPersonalData" class="primary"
                        (change)="showPersonalDataChanged()" />
                    <span class="slider slider-sm round"></span>
                </label>
                <label class="fs-md">Facility Filtered Data</label>
            </div>
        </div> -->
    </div>
    <div class="kt-content kt-grid__item kt-grid__item--fluid" id="kt_content">
        <div class="col-md-12 p-0">
            <div class="kt-portlet kt-portlet--mobile">
                <div class="kt-portlet__head kt-portlet__head--lg">
                    <div class="kt-portlet__head-label">
                        <h3 class="kt-portlet__head-title">
                            Offline Kiosk Log
                        </h3>
                    </div>
                    <div class="kt-portlet__head-toolbar">
                        <select name="month" [(ngModel)]="selectedMonth" class="form-control form-control-sm"
                            (change)="reloadDataTable()">
                            <option *ngFor="let m of months" [value]="m.id">{{m.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="kt-portlet__body">
                    <div class="dataTables_wrapper dt-bootstrap4 no-footer" *blockUI="'container-blockui'">
                        <app-kiosk-filter-box [companyId]="companyId"
                            [filterModel]="filterModel" (applyFilterEmitter)="doFilter()" (resetFilterEmitter)="resetFilter()" #filterBox>
                        </app-kiosk-filter-box>
                        <div class="row">
                            <div class="col-md-12">
                                <table datatable [dtOptions]="dtOptions" data-page="2"
                                    class="table table-hover break-all">
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-kiosk-offline-timestamp #kioskTimestamp [timestamps]="selectedKioskTimestamps">
</app-kiosk-offline-timestamp>